import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useResizeObserverErrorSuppression } from "./utils/resizeObserverFix";
import { Toaster } from "./components/ui/sonner";
import usePageTracking from "./hooks/usePageTracking";
import { Header } from "./components/Header";
import { HeroSection } from "./components/HeroSection";
import { ProductsSection } from "./components/ProductsSection";
import { ServicesSection } from "./components/ServicesSection";
import { InstallationsSection } from "./components/InstallationsSection";
import { TestimonialsSection } from "./components/TestimonialsSection";
import { ContactSection } from "./components/ContactSection";
import { Footer } from "./components/Footer";
import { AdminPage } from "./components/AdminPage";
import { ProductDetailPage } from "./components/ProductDetailPage";
import PaymentPage from "./components/PaymentPage";
import PaymentSuccess from "./components/PaymentSuccess";
import PaymentCancel from "./components/PaymentCancel";

const Home = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const showAdmin = params.get('admin') === '1';

  return (
    <div className="min-h-screen bg-white relative">
      <Header />
      <main>
        <HeroSection />
        <ProductsSection />
        <ServicesSection />
        <InstallationsSection />
        <TestimonialsSection />
        <ContactSection />
      </main>
      <Footer />
      <Toaster />

      {showAdmin && (
        <div className="fixed inset-0 bg-black/60 z-50 overflow-auto">
          <div className="min-h-screen bg-gray-50">
            <AdminPage />
          </div>
        </div>
      )}
    </div>
  );
};

function AppContent() {
  // Hook de tracking des visites
  usePageTracking();
  
  return (
    <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/manage" element={<AdminPage />} />
          <Route path="/product/:id" element={<><Header /><ProductDetailPage /><Footer /></>} />
          <Route path="/payment" element={<PaymentPage />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          {/* Fallback route to avoid blank page on unknown paths */}
          <Route path="*" element={<Home />} />
        </Routes>
  );
}

function App() {
  useResizeObserverErrorSuppression();
  
  return (
    <div className="App">
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;